module.exports = __webpack_public_path__ + "static/img/btn_yes.eea8b6bc.png";